import * as React from "react";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

// event-mismatch
import { IProps } from "./EventMismatch.d";
import { styles } from "./EventMismatch.styles";

///////////////
// Component //
///////////////

class EventMismatchComponent extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <div className={this.props.classes.container}>
        <div className={this.props.classes.eventMissingImage} />
        <Typography variant="h6" className={this.props.classes.h6}>
          We can't view this event because it's on a calendar that Clockwise doesn't have access to.
        </Typography>
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////

export const EventMismatch = withStyles(styles)(EventMismatchComponent);
